/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'users';

/** API route prefix — shared by `model.js` and list descriptor routes. */
export const FETCH_ROUTE = 'user';

/** Singular entity name for reducers/notifications. Often equals `FETCH_ROUTE`. */
export const ENTITY_NAME = 'user';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'users';
